import { extendTheme, ThemeConfig } from '@chakra-ui/react';
import { semanticTokens, colors } from './colors';
import { components } from './components/component.styles';
import { typography } from './typography';
import { spacing } from './spacing';
import { shadows } from './shadows';

const config: ThemeConfig = {
  initialColorMode: 'light',
  useSystemColorMode: false,
};

export const theme = extendTheme({
  config,
  colors,
  ...typography,
  ...spacing,
  shadows,
  components,
  semanticTokens,
  styles: {
    global: (props: { colorMode: 'light' | 'dark' }) => ({
      body: {
        bg: props.colorMode === 'light' ? 'white' : 'gray.800',
        color: props.colorMode === 'light' ? 'gray.800' : 'whiteAlpha.900',
      },
    }),
  },
});
